var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseModal',{attrs:{"padded":false},on:{"close":_vm.handleClose}},[_c('VideoPlayer',{attrs:{"autoplay":true,"url":_vm.video.videoUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }